import styles from "./Privacy.module.css";

export function Privacy({ onBack }: { onBack: () => void }) {
  return (
    <div className={styles.container}>
      <button className={styles.backButton} onClick={onBack}>&larr; Back</button>
      <h1 className={styles.title}>Privacy Policy</h1>
      <p className={styles.updated}>Last updated: March 22, 2026</p>

      <section>
        <h2>What we collect</h2>
        <p>
          When you sign in with Google, we receive your <strong>name</strong>, <strong>email address</strong>,
          and <strong>profile picture</strong> from Google. We use this information solely to create and
          identify your Griddle account.
        </p>
        <p>
          We also store your <strong>puzzle progress</strong> (which puzzles you've solved, swap counts, and
          solve times) to sync your stats across devices.
        </p>
      </section>

      <section>
        <h2>How we use your data</h2>
        <ul>
          <li>Display your name and avatar when you're signed in</li>
          <li>Sync your puzzle progress across devices</li>
          <li>Link multiple sign-in providers (e.g., Google, Apple) to the same account using your email address</li>
        </ul>
        <p>We do not sell, share, or use your data for advertising purposes.</p>
      </section>

      <section>
        <h2>Data storage</h2>
        <p>
          Your account and progress data are stored securely on Cloudflare's infrastructure (D1 database and
          Workers KV). Session cookies are <code>HttpOnly</code> and <code>Secure</code>.
        </p>
        <p>
          Puzzle progress is also stored locally in your browser's localStorage for offline play.
          You can clear this data at any time using your browser settings.
        </p>
      </section>

      <section>
        <h2>Third-party services</h2>
        <ul>
          <li><strong>Google Identity Services</strong> — for sign-in authentication</li>
          <li><strong>Cloudflare</strong> — for hosting, CDN, and data storage</li>
          <li><strong>Sentry</strong> — for error tracking (no personal data is sent)</li>
        </ul>
      </section>

      <section>
        <h2>Your rights</h2>
        <p>
          You can sign out at any time using the account menu. To delete your account and all associated data,
          contact us at <a href="mailto:support@griddle.gg">support@griddle.gg</a>.
        </p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>
          Questions about this policy? Email <a href="mailto:support@griddle.gg">support@griddle.gg</a>.
        </p>
      </section>
    </div>
  );
}
